import {GetMissionsHistoryResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.types';
import {mobileOnlyLinaria, SPACING, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {CoinsMission} from '../../../features/Coins/CoinsWallet/CoinsWalletContent/CoinsMissions/CoinsMission';

export const CoinsLatestAchievementsView: React.FC<
  GetMissionsHistoryResponse
> = ({items}) => (
  <Wrapper>
    {items.map((item, index) => (
      <React.Fragment key={index}>
        {item.type?.$case === 'mission' ? (
          <CoinsMission
            data-testid="latestAchievement"
            {...item.type.mission}
          />
        ) : (
          <AllMissionsCompleted>
            <Text weight="mediumBold">{item.type?.content?.description}</Text>
          </AllMissionsCompleted>
        )}
      </React.Fragment>
    ))}
  </Wrapper>
);

const Wrapper = styled.div`
  ${mobileOnlyLinaria(`
    margin: ${SPACING['Y.Lg']} ${SPACING['X.Lg']};
  `)}
`;

const AllMissionsCompleted = styled.div`
  padding: ${SPACING['Y.Md']} ${SPACING['X.Lg']};
  text-align: center;

  > span {
    line-height: 1.45;
  }
`;
